module.exports = {"id":"229237","name":"Manuel Akanji","rating":"74","photo":"./data/images/photos/3/229237.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManuelAkanji0.json
// module id = 2678
// module chunks = 0